import React, { useState } from "react";
import { Table } from "antd";
import Box from "@mui/material/Box";
import { Space, Tooltip } from "antd";
import styles from "./Table.module.css";
import VizHeader from "../VizHeader/VizHeader";
import { SearchOutlined, SyncOutlined } from "@ant-design/icons";
import { DebounceInput } from "react-debounce-input";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import { PersonAdd } from "@mui/icons-material";

export const customPaginationStyle = {
  marginRight: "10px",

  // Apply marginRight to the pagination component
};
const textStyles = {
  fontSize: "16px",
  color: "#2A364A",
  fontWeight: "500",
  // lineHeight: "24px",

  // wordBreak: "break-word",
  marginRight: "5px"

};
const textStylesHeader = {
  fontSize: "18px",
  color: "#2A364A",
  fontWeight: "500",
  // lineHeight: "24px",

  // wordBreak: "break-word",
  marginRight: "5px"

};
const filtering = (row, text) => {
  // console.log("row", row);
  // console.log("text", text);
  return (
    row &&
    row?.filter((row) =>
      Object.values(row)?.some((value) =>
        value?.toString().toLowerCase().includes(text.toLowerCase())
      )
    )
  );
};

function SearchBar({
  searchValue,
  handleSearch,
  setSearchValue,
  setCurrentPage,
}) {
  return (
    <>
      <Space.Compact>
        <span className={styles.search}>
          <SearchOutlined />
          <DebounceInput
            debounceTimeout={0}
            placeholder="Search"
            autoComplete="off"
            outline={true}
            onChange={handleSearch}
            value={searchValue}
            allowClear
            style={{ border: "none", paddingLeft: "10px" }}
          />

          {searchValue.length > 2 && (
            <>
              <span
                className={styles.cross}
                onClick={() => {
                  setSearchValue("");
                  setCurrentPage(1);
                }}
              >
                <svg
                  fill-rule="evenodd"
                  viewBox="64 64 896 896"
                  focusable="false"
                  data-icon="close-circle"
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z"></path>
                </svg>
              </span>
            </>
          )}
        </span>
      </Space.Compact>
    </>
  );
}


const StaticTableAnt = ({
  columns,
  data,
  searchValue,
  //   handleSearch,
  setSearchValue,
  count,
  Header,
  currentPage,
  setCurrentPage,
  isRefreshing,
  setIsRefreshing,
  showRefresh = false,
  fetchData,
  setShowMore,
  searchBoolean,
  channel,
  sortInfo,
  setSortInfo
}) => {
  const handleSearch = (event) => {
    setCurrentPage(1);
    setSearchValue(event.target.value);
  };
  const dispatch = useDispatch();

  const { setReload } = bindActionCreators(Actions, dispatch);
  const slack = useSelector((state) => state.slackTab);
  const [pageSize, setPageSize] = React.useState(10);
  const handlePageChange = (page, pageSize) => {
    setPageSize(pageSize);
    setCurrentPage(page);

    if (showRefresh) {
      if (page !== currentPage) setShowMore();
    }
  };
  const refreshData = () => {
    setReload(true);
    fetchData();
  };
  const processedData = React.useMemo(() => {
    let filtered = data;
    if (searchValue.length > 0) {
      filtered = filtering(data, searchValue);
    }

    if (sortInfo && sortInfo.columnKey) {
      const { columnKey, order } = sortInfo;
      filtered = [...filtered].sort((a, b) => {
        const valA = a[columnKey];
        const valB = b[columnKey];

        if (typeof valA === 'string') {
          return order === 'ascend'
            ? valA.localeCompare(valB)
            : valB.localeCompare(valA);
        }

        return order === 'ascend' ? valA - valB : valB - valA;
      });
    }

    return filtered;
  }, [data, searchValue, sortInfo]);

  const valueData =
  Array.isArray(processedData) &&
  processedData.length > 0 &&
  processedData[0]?.Geo;
  // console.log("processedData",processedData[0])
  return (
    <div>
      {" "}
      <div
        style={{ display: "flex", justifyContent: "center", width: "99.8%" }}
      >
        {" "}
        <span style={textStylesHeader}>
        {Header}
        </span>
        {/* <VizHeader type={4} isBold={true}>
      
        </VizHeader> */}
      </div>
      <div className={styles.header}>
        {searchBoolean && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              // width: "60%",
            }}
          >
            <SearchBar
              searchValue={searchValue}
              handleSearch={handleSearch}
              setSearchValue={setSearchValue}
              setCurrentPage={setCurrentPage}
            />

            {/* {channel && (
              <Tooltip
                color="#fff"
                title={() => {
                  return (
                    <span
                      style={{ color: "black", textTransform: "capitalize" }}
                    >
                      Refresh
                    </span>
                  );
                }}
              >
                <span style={{ paddingRight: "2git px" }}>
                  <SyncOutlined
                    colSpan={3}
                    span={2}
                    onClick={() => refreshData()}
                    spin={isRefreshing}
                    style={{ fontSize: "16px" }}
                  />
                </span>
              </Tooltip>
            )} */}
            {/* <span style={{display:"flex",gap:"5px"}}>
              <span style={textStyles}>
                Location:
              </span>
              <span  style={textStyles}>
              {valueData}
              </span>
            </span> */}

            {showRefresh && (
              <Tooltip
                color="#fff"
                title={() => {
                  return (
                    <span
                      style={{ color: "black", textTransform: "capitalize" }}
                    >
                      Refresh
                    </span>
                  );
                }}
              >
                <span style={{ paddingRight: "2git px" }}>
                  <SyncOutlined
                    colSpan={3}
                    span={2}
                    onClick={() => refreshData()}
                    spin={slack.reload}
                    style={{ fontSize: "16px" }}
                  />
                </span>
              </Tooltip>
            )}
          </Box>
        )}
      </div>
      <Box sx={{ mt: 2 }}>
        <style jsx>
          {`
            .ant-table-thead th:nth-child(0) {
              z-index: 0;
            }
          `}{" "}
        </style>
        <style jsx>
          {`
            .ant-table-thead th:nth-child(1) {
              z-index: 0;
            }
          `}{" "}
        </style>
        <style jsx>
          {`
            .ant-table-thead th:nth-child(2) {
              z-index: 0;
            }
          `}{" "}
        </style>
        <style jsx>
          {`
            .ant-table-thead th:nth-child(3) {
              z-index: 0;
            }
          `}{" "}
        </style>
        <style jsx>
          {`
            .ant-table-thead th:nth-child(4) {
              z-index: 0;
            }
          `}{" "}
        </style>
        <style jsx>
          {`
            .ant-table-thead th:nth-child(5) {
              z-index: 0;
            }
          `}{" "}
        </style>
        <style jsx>
          {`
            .ant-table-thead th:nth-child(6) {
              z-index: 0;
            }
          `}{" "}
        </style>

        <style jsx>
          {`
            .ant-table-thead th:nth-child(7) {
              z-index: 0;
            }
          `}{" "}
        </style>
        <Table
          rowClassName={(record, index) =>
            index % 2 === 0 ? "table-row-light" : "table-row-dark"
          }
          columns={columns}
          showSorterTooltip={false}
          dataSource={processedData}
          pagination={{
            showSizeChanger: true,
            pageSizeOptions: ["10", "25", "50"],
            onChange: handlePageChange,
            current: currentPage, // Set the current page
            pageSize: pageSize,
            style: customPaginationStyle,
            dropdownPlacement: "top",
          }}
          style={{ boxShadow: "7px 7px 20px lightgrey" }}
          scroll={{
            // x: 600,
            y: 550,
          }}
          responsive
          onChange={(pagination, filters, sorter) => {
            setSortInfo(sorter);
          }}
        />
      </Box>
    </div>
  );
};

export default StaticTableAnt;
